/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import menuTypes from 'constants/menuTypes';
import { useTranslate } from 'hooks/useTranslate';

import AiAgentHeader from 'modules/ai/components/AiAgentHeader';
import AiAgentTitle from 'modules/ai/components/AiAgentTitle';
import AiAgentInput from 'modules/ai/components/AiAgentInput';
import AiAgentQuickActions from 'modules/ai/components/AiAgentQuickActions';
import AiAgentConversation, {
  AiAgentConversationMessage,
} from 'modules/ai/components/AiAgentConversation';

import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { getMockResponse } from 'modules/ai/utils/getMockResponse';
import { defaultQuestions } from 'modules/ai/constants/defaultQuestions';

import './SocietyAiAgent.scss';

const SocietyAiAgent = () => {
  const { t } = useTranslate();

  const [input, setInput] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [conversations, setConversations] = useState<
    AiAgentConversationMessage[]
  >([]);
  const [hasStartedChat, setHasStartedChat] = useState(false);

  const userAvatarUrl = useSelector((state: State) => state.user.image);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  useGetMenu(menuTypes.NULL);

  const handleSubmit = async () => {
    if (!input.trim()) return;

    const questionId = Date.now().toString();
    const question: AiAgentConversationMessage = {
      id: questionId,
      type: 'question',
      content: input.trim(),
      timestamp: new Date(),
    };

    setConversations((prev) => [...prev, question]);
    setHasStartedChat(true);
    setIsProcessing(true);
    setInput('');

    setTimeout(() => {
      const responseContent = getMockResponse(input);
      const response: AiAgentConversationMessage = {
        id: (Date.now() + 1).toString(),
        type: 'response',
        content: responseContent,
        timestamp: new Date(),
      };

      setConversations((prev) => [...prev, response]);
      setIsProcessing(false);
    }, 1500);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    const hasPressedMetaOrCtrl = e.metaKey || e.ctrlKey;
    if (e.key === 'Enter' && hasPressedMetaOrCtrl) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleQuickAction = (entity: string) => {
    const questions = defaultQuestions[entity as keyof typeof defaultQuestions];
    if (questions && questions.length > 0) {
      const randomQuestion =
        questions[Math.floor(Math.random() * questions.length)];
      setInput(randomQuestion);
    }
  };

  const subTitleText = t('AI_HeaderSubTitle', {
    societyName: actualSociety?.name,
  });

  return (
    <div className="ai-agent-container">
      <AiAgentHeader hasStartedChat={hasStartedChat} />

      <div className="ai-agent-wrapper">
        <AiAgentTitle hasStartedChat={hasStartedChat} subTitle={subTitleText} />

        <AiAgentConversation
          hasStartedChat={hasStartedChat}
          conversations={conversations}
          isProcessing={isProcessing}
          userAvatarUrl={userAvatarUrl}
        />

        <AiAgentInput
          input={input}
          onKeyDown={handleKeyDown}
          onChange={(e) => setInput(e.target.value)}
          onSubmit={handleSubmit}
          isProcessing={isProcessing}
          hasStartedChat={hasStartedChat}
        />

        {!hasStartedChat && (
          <AiAgentQuickActions onClickAction={handleQuickAction} />
        )}
      </div>
    </div>
  );
};

export default SocietyAiAgent;
